<div
    [id]="id + '_' + filter.id"
    class="agpr-filterKeyword"
    [ngClass]="{'social': style === agprComponentStyle.social}"
>
    <div
        class="agpr-filterKeyword-content"
        [formGroup]="keywordFilter"
    >
        <div class="agpr-filterKeyword-toolbar">
            <agpr-button
                [id]="id + '_' + filter.id + '_modeTogglebutton'"
                [style]="buttonTypes.textToggle"
                [label]="filter.filterMode === keywordMode.expert ? 'Monitoring.ExpertBooleanSearch.SwitchToStandardMode.header' : 'Monitoring.ExpertBooleanSearch.SwitchToExpertMode.header'"
                (click)="toggleMode()"
            ></agpr-button>
            @if (filter.filterMode === keywordMode.standard) {
                <agpr-button
                    [id]="id + '_' + filter.id + '_addKeywordGroup'"
                    [style]="buttonTypes.icon"
                    [icon]="'fa-regular fa-duotone fa-square-plus'"
                    [tooltip]="hasEmptyKeywordGroup ? 'Monitoring.keyWords.addKeywordGroup.disabled' : 'Monitoring.keyWordGroup.addKeywordGroup'"
                    (click)="addKeywordGroup()"
                    [disabled]="hasEmptyKeywordGroup"
                ></agpr-button>
            }
        </div>
        <agpr-scroll-panel #scrollPanel>
            @switch (filter.filterMode) {
                @case (keywordMode.standard) {
                    <div class="agpr-filterKeyword-standardMode">
                        <ul
                            class="agpr-filterKeyword-keywordGroup-list"
                            formArrayName="keywordGroups"
                            agprListKeyboardNavigation
                            [list]="keywordGroups.controls"
                        >
                            @for (group of keywordGroups.controls; track group; let i = $index, count = $count;) {
                                <li
                                    #groupItem
                                    class="agpr-filterKeyword-keywordGroup-listItem"
                                    [formGroupName]="i"
                                >
                                    <div class="agpr-filterKeyword-keywordGroup-keywords">
                                        <div class="agpr-filterKeyword-keywordGroup-keywords-header">
                                            @if (i !== 0) {
                                                <div class="agpr-filterKeyword-keywordGroup-keywords-logicOperator">
                                                    {{ 'and' | localize }}
                                                </div>
                                            }
                                            <h4>{{ 'Monitoring.keyWordGroup.keywordGroupName' | localize: { id: i + 1 } }}</h4>
                                            @if (count > 1) {
                                                <agpr-button
                                                    [id]="id + '_' + filter.id + '_deleteKeywordGroup' + '_' + i"
                                                    class="agpr-filterKeyword-keywordGroup-keywords-deleteButton"
                                                    [style]="buttonTypes.icon"
                                                    icon="fa-regular fa-duotone fa-trash-can"
                                                    tooltip="Monitoring.keyWordGroup.deleteKeywordGroup"
                                                    (click)="deleteKeywordGroup(i)"
                                                ></agpr-button>
                                            }
                                        </div>
                                        <agpr-include-exclude-chips
                                            [id]="id + '_' + filter.id + '_keywords' + '_' + i"
                                            class="agpr-filterKeyword-keywordGroup-keywords-includeExcludeChips"
                                            formControlName="keywords"
                                            headerLabel="Monitoring.filtersLocalization.keywords"
                                            placeholder="Monitoring.search.enterKeywordsOrPhrases"
                                            [chipValidations]="keywordChipValidations"
                                            [splitOnPattern]="splitOnPattern"
                                        ></agpr-include-exclude-chips>
                                        @if (group.get('keywords')?.errors?.['keywordsError']) {
                                            <agpr-form-message class="agpr-filterKeyword-errorFormMessage">
                                                {{ group.get('keywords')?.errors?.['keywordsError']}}
                                            </agpr-form-message>
                                        }
                                    </div>
                                    <ng-container *ngTemplateOutlet="searchContextsTemplate; context: { idPrefix: id + '_' + filter.id + '_' + i, formGroup: group }"></ng-container>
                                </li>
                            }
                        </ul>
                        @if (keywordGroups.errors?.maxLengthError) {
                            <agpr-form-message class="agpr-filterKeyword-errorFormMessage">
                                {{ keywordGroups.errors?.maxLengthError }}
                            </agpr-form-message>
                        }
                        @if (keywordGroups.errors?.keywordGroupsError) {
                            <agpr-form-message class="agpr-filterKeyword-errorFormMessage">
                                {{ keywordGroups.errors?.keywordGroupsError }}
                            </agpr-form-message>
                        }
                    </div>
                }
                @case (keywordMode.expert) {
                    <div
                        class="agpr-filterKeyword-expertMode"
                        formGroupName="expertQuery"
                    >
                        <agpr-textarea-input
                            [id]="id + '_' + filter.id + '_exportMode_textarea'"
                            class="agpr-filterKeyword-expertMode-expertQuery"
                            formControlName="filter"
                            label="Monitoring.ExpertBooleanSearch.input.textArea"
                            [placeholder]="'Monitoring.ExpertBooleanSearch.input.placeholder' | localize"
                            [style]="style"
                            [bottomMargin]="false"
                        ></agpr-textarea-input>
                        @if (expertQuery.hasError('expertQueryError')) {
                            <agpr-form-message class="agpr-filterKeyword-errorMessage">
                                {{ expertQuery.errors?.['expertQueryError'] }}
                            </agpr-form-message>
                        }
                        <ng-container *ngTemplateOutlet="searchContextsTemplate; context: { idPrefix: id + '_' + filter.id + '_expertMode', formGroup: expertQuery }"></ng-container>
                    </div>
                }
            }
        </agpr-scroll-panel>
    </div>
</div>

<ng-template #searchContextsTemplate let-idPrefix="idPrefix" let-formGroup="formGroup">
    <div class="agpr-filterKeyword-searchContexts" [formGroup]="formGroup">
        <div class="agpr-filterKeyword-searchContexts-label">
            <label>
                {{ 'Monitoring.filter.keywords.searchWithIn' | localize }}
            </label>
            <span
                role="img"
                class="fa-regular fa-circle-info agpr-infoIconStyle"
                agprTooltip="Monitoring.filter.keywords.searchWithIn.tooltip"
                tooltipPosition="right"
                [escape]="false"
            ></span>
        </div>
        <div class="agpr-filterKeyword-searchContexts-options">
            <agpr-checkbox
                [id]="idPrefix + '_headline'"
                formControlName="searchContexts"
                label="Monitoring.filter.keywords.headline"
                [value]="searchContextsEnum.header"
            ></agpr-checkbox>
            <agpr-checkbox
                [id]="idPrefix + '_lead'"
                formControlName="searchContexts"
                label="Monitoring.filter.keywords.lead"
                [value]="searchContextsEnum.lead"
            ></agpr-checkbox>
            <agpr-checkbox
                [id]="idPrefix + '_body'"
                formControlName="searchContexts"
                label="Monitoring.filter.keywords.body"
                [value]="searchContextsEnum.body"
            ></agpr-checkbox>
        </div>
    </div>
</ng-template>
